var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('main-navigation-drawer'),_c('main-app-bar'),_c('main-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }